
import React, {Component} from "react";
import PageTitle from "../../Components/Theme/PageTitle/index.js";
import DashboardLayout from "../../Components/Theme/DashboardLayout/index.js";

export default class BlankPage extends Component {


    render() {
        return (
            <DashboardLayout>
                {/*** Page Title ***/}
                <PageTitle title={'Blank Page'}
                           subTitle={'New Blank Page'}/>

            </DashboardLayout>
        )
    }
}
